<template>
  <div id="live_games_containier" class="border-padding">
  <main>
    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="$route.params.game_id">
      <h2 v-if="game_info && game_info.home_win_probability && game_info.clock != ''">{{game_info.visitor_team}} {{game_info.visitor_score}} ({{game_info.visitor_win_probability}}%) - {{game_info.home_team}} {{game_info.home_score}} ({{game_info.home_win_probability}}%) ({{game_info.status}} {{game_info.clock}})</h2>
      <h2 v-else-if="game_info && game_info.home_win_probability && game_info.clock == ''">{{game_info.visitor_team}} {{game_info.visitor_score}} ({{game_info.visitor_win_probability}}%) - {{game_info.home_team}} {{game_info.home_score}} ({{game_info.home_win_probability}}%) ({{game_info.status}})</h2>
      <h2 v-else-if="game_info && game_info.clock != ''">{{game_info.visitor_team}} {{game_info.visitor_score}} - {{game_info.home_team}} {{game_info.home_score}} ({{game_info.status}} {{game_info.clock}})</h2>
      <h2 v-else-if="game_info && game_info.clock == ''">{{game_info.visitor_team}} {{game_info.visitor_score}} - {{game_info.home_team}} {{game_info.home_score}} ({{game_info.status}})</h2>
      <router-link  :to="{ name: 'live', params: { league: $parent.league, game_id: $route.params.game_id, type: 'team' }}">Team Stats</router-link > --
      <router-link  :to="{ name: 'live', params: { league: $parent.league, game_id: $route.params.game_id, type: 'player' }}">Player Stats</router-link > --
      <router-link  :to="{ name: 'live', params: { league: $parent.league, game_id: $route.params.game_id, type: 'lineup' }}">Lineup Stats</router-link > --
      <router-link  :to="{ name: 'live', params: { league: $parent.league, game_id: $route.params.game_id, type: 'possession-start' }}">Possession Start Type Stats</router-link > --
      <router-link  :to="{ name: 'live', params: { league: $parent.league, game_id: $route.params.game_id, type: 'game-flow' }}">Game Flow</router-link > --
      <router-link  :to="{ name: 'live', params: { league: $parent.league, game_id: $route.params.game_id, type: 'possession-by-possession' }}">Possession-By-Possession</router-link >

      <div v-if="$route.params.type == 'team' && headers.length > 0" id="team-container">
        <div id="team-container2">
          <vue-good-table
            :columns="headers"
            :rows="rows"
            :fixed-header="true"
            :sort-options="{ enabled: false}"
            max-height="80vh">
          </vue-good-table>
        </div>
      </div>
      <div v-if="$route.params.type == 'possession-start' && headers.length > 0" id="team-container">
        <div id="team-container2">
          <vue-good-table
            :columns="headers"
            :rows="rows"
            :groupOptions="{enabled: true}"
            :fixed-header="true"
            :sort-options="{ enabled: false}"
            max-height="80vh">>
          </vue-good-table>
        </div>
      </div>
      <div v-if="($route.params.type == 'player' || $route.params.type == 'lineup') && visitor_headers.length > 0">
        <p v-if="$route.params.type == 'lineup' && home_rows.length == 0">Lineup Stats Unavailable - Error parsing lineups from PBP</p>
        <p v-if="$route.params.type == 'player'">*Current Players</p>
        <p v-if="$route.params.type == 'lineup'">*Current Lineup</p>
        <h4 v-if="game_info">{{game_info.visitor_team}}</h4>
        <vue-good-table
          :columns="visitor_headers"
          :rows="visitor_rows"
          :sort-options="{ enabled: false}">
        </vue-good-table>
      </div>
      <div v-if="($route.params.type == 'player' || $route.params.type == 'lineup') && home_headers.length > 0">
        <h4 v-if="game_info">{{game_info.home_team}}</h4>
        <vue-good-table
          :columns="home_headers"
          :rows="home_rows"
          :sort-options="{ enabled: false}">
        </vue-good-table>
        <p v-if="$route.params.type == 'player'">Stats showing N/A aren't available yet because of an error parsing lineups from PBP</p>
      </div>
      <div id="game_flow_chart_container" v-if="$route.params.type == 'game-flow'">
        <div>
          <h3 v-if="game_info">{{game_info.visitor_team}}</h3>
          <svg id="visitor" width="800" height="400"></svg>
        </div>
        <div>
          <svg id="margin" width="800" height="100"></svg>
        </div>
        <div>
          <h3 v-if="game_info">{{game_info.home_team}}</h3>
          <svg id="home" width="800" height="400"></svg>
        </div>
      </div>
      <div id="possession_by_possession_container" v-if="$route.params.type == 'possession-by-possession' && possessions.length > 0">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Score</th>
              <th>{{game_info.home_team}}</th>
              <th></th>
              <th>Length</th>
              <th></th>
              <th>{{game_info.visitor_team}}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(possession, i) in possessions">
              <tr v-if="possession.home_team_on_offense && possession.start_period" v-bind:key=i class="home_possession period_start">
                <td>{{possession.number}}</td>
                <td>{{possession.score}}</td>
                <td><div v-for="(event, j) in possession.events" v-bind:key="j">{{event}}</div></td>
                <td v-if="possession.possession_result == 'scored'" class="scored">    </td>
                <td v-else-if="possession.possession_result == 'turnover'" class="turnover">    </td>
                <td v-else>    </td>
                <td class="home_time">{{possession.possession_length}}</td>
                <td>    </td>
                <td></td>
              </tr>
              <tr v-else-if="possession.home_team_on_offense" v-bind:key=i class="home_possession">
                <td>{{possession.number}}</td>
                <td>{{possession.score}}</td>
                <td><div v-for="(event, j) in possession.events" v-bind:key="j">{{event}}</div></td>
                <td v-if="possession.possession_result == 'scored'" class="scored">    </td>
                <td v-else-if="possession.possession_result == 'turnover'" class="turnover">    </td>
                <td v-else>    </td>
                <td class="home_time">{{possession.possession_length}}</td>
                <td>    </td>
                <td></td>
              </tr>
              <tr v-else-if="possession.start_period" v-bind:key=i class="visitor_possession period_start">
                <td>{{possession.number}}</td>
                <td>{{possession.score}}</td>
                <td></td>
                <td>    </td>
                <td class="visitor_time">{{possession.possession_length}}</td>
                <td v-if="possession.possession_result == 'scored'" class="scored">    </td>
                <td v-else-if="possession.possession_result == 'turnover'" class="turnover">    </td>
                <td v-else>    </td>
                <td><div v-for="(event, j) in possession.events" v-bind:key="j">{{event}}</div></td>
              </tr>
              <tr v-else v-bind:key=i class="visitor_possession">
                <td>{{possession.number}}</td>
                <td>{{possession.score}}</td>
                <td></td>
                <td>    </td>
                <td class="visitor_time">{{possession.possession_length}}</td>
                <td v-if="possession.possession_result == 'scored'" class="scored">    </td>
                <td v-else-if="possession.possession_result == 'turnover'" class="turnover">    </td>
                <td v-else>    </td>
                <td><div v-for="(event, j) in possession.events" v-bind:key="j">{{event}}</div></td>
              </tr>
            </template>
          </tbody>
        </table>
        <ul class="legend">
          <li><span class="scored"></span>Points Scored</li>
          <li><span class="turnover"></span>Turnover</li>
        </ul>
      </div>
    </div>
    <div v-else>
      <h3>Live Games:</h3>
      <div v-if="games.length == 0">
        No Live Games
      </div>
      <ul v-for="game in games" :key="game.gameid">
        <li class="link">
          {{game.away}} - {{game.home}} ({{game.time}})
          <router-link :to="{ name: 'live', params: { league: $parent.league, game_id: game.gameid, type: 'team' }}">Team Stats</router-link> --
          <router-link :to="{ name: 'live', params: { league: $parent.league, game_id: game.gameid, type: 'player' }}">Player Stats</router-link> --
          <router-link :to="{ name: 'live', params: { league: $parent.league, game_id: game.gameid, type: 'lineup' }}">Lineup Stats</router-link> --
          <router-link :to="{ name: 'live', params: { league: $parent.league, game_id: game.gameid, type: 'possession-start' }}">Possession Start Type Stats</router-link> --
          <router-link :to="{ name: 'live', params: { league: $parent.league, game_id: game.gameid, type: 'game-flow' }}">Game Flow</router-link> --
          <router-link :to="{ name: 'live', params: { league: $parent.league, game_id: game.gameid, type: 'possession-by-possession' }}">Possession-By-Possession</router-link>
        </li>
      </ul>
    </div>
  </main>
  </div>
</template>

<script>
import axios from 'axios'

const d3 = require('d3')

export default {
  name: 'Live',
  data () {
    return {
      loading: false,
      show_error_message: false,
      rows: [],
      games: [],
      game_info: undefined,
      headers: [],
      home_headers: [],
      visitor_headers: [],
      home_rows: [],
      visitor_rows: [],
      stints: {},
      possessions: []
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'loadData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      this.$router.push({name: 'live', params: {league: this.$parent.league}})
    },
    loadData () {
      if (this.ws) {
        this.ws.close()
      }
      if (!this.$route.params.game_id) {
        this.getLiveGames()
      } else if (this.$route.params.game_id && this.$route.params.type) {
        this.rows = []
        this.home_rows = []
        this.visitor_rows = []
        this.stints = {}
        this.possessions = []
        this.game_info = undefined
        this.getGameData(this.$route.params.game_id, this.$route.params.type)
      }
    },
    getLiveGames () {
      this.fetchGames()
    },
    getGameData (gameId, type) {
      this.show_error_message = false
      this.rows = []
      this.home_rows = []
      this.visitor_rows = []
      this.stints = {}
      this.possessions = []
      this.fetchData(gameId, type)
    },
    sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async fetchGames () {
      var url = process.env.API_BASE_URL + 'live/games/' + this.$parent.league
      // Retrieve the initial operation status
      try {
        let pollingResponse = await axios.get(url)
        var data = pollingResponse.data
        this.games = data.game_data
      } catch (error) {
        data = error.message
      }
      // make request every 30 seconds while there are live games
      while (data.live_games !== 0) {
        await this.sleep(30000)
        try {
          let pollingResponse = await axios.get(url)
          data = pollingResponse.data
          this.games = data.game_data
        } catch (error) {
          data = error.message
        }
      }
    },
    displayGameData (gameData, type) {
      if (gameData !== undefined) {
        this.game_info = gameData.game_info
        if (type === 'team' || type === 'possession-start') {
          this.rows = gameData.rows
          this.headers = gameData.headers
        } else if ((type === 'player' || type === 'lineup')) {
          this.home_rows = gameData.home_rows
          this.home_headers = gameData.home_headers
          this.visitor_rows = gameData.visitor_rows
          this.visitor_headers = gameData.visitor_headers
        } else if (type === 'game-flow') {
          var homeStints = gameData.home_stints
          var visitorStints = gameData.visitor_stints
          var maxTime = gameData.max_time
          this.addStintChart('svg#home', homeStints, maxTime, 'home-team')
          this.addStintChart('svg#visitor', visitorStints, maxTime, 'visitor-team')
          this.addScoreMargin(gameData.score_margins, maxTime)
        } else if (type === 'possession-by-possession') {
          this.possessions = gameData.possessions
        }
      }
    },
    async fetchData (gameId, type) {
      var url = process.env.API_BASE_URL + 'live/game/' + gameId + '/' + type
      try {
        let pollingResponse = await axios.get(url)
        var data = pollingResponse.data
        this.displayGameData(data.game_data, type)
      } catch (error) {
        data = error.message
      }

      // make request every 30 seconds if game is not final
      while (data.status !== 'Final') {
        await this.sleep(30000)
        try {
          let pollingResponse = await axios.get(url)
          data = pollingResponse.data
          this.displayGameData(data.game_data, type)
        } catch (error) {
          data = error.message
        }
      }
    },
    addStintChart (svgContainer, data, maxTime, barClass) {
      d3.select(svgContainer).html('')
      var svg = d3.select(svgContainer)
      var margin = {top: 20, right: 20, bottom: 20, left: 100}
      var width = +svg.attr('width') - margin.left - margin.right
      var height = +svg.attr('height') - margin.top - margin.bottom
      var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      var x = d3.scaleLinear()
        .rangeRound([0, width])

      var y = d3.scaleBand()
        .rangeRound([0, height])
        .paddingInner(0.05)
        .align(0.1)

      var names = []
      for (var i = 0; i < data.length; i++) {
        data[i]['number'] = i + 1
        names.push(data[i]['name'])
        for (var j = 0; j < data[i].stints.length; j++) {
          data[i].stints[j]['number'] = i + 1
        }
      }

      x.domain([0, maxTime / 60])
      y.domain(data.map(function (d) { return d.number }))

      g.append('g')
        .selectAll('g')
        .data(data)
        .enter().append('g')
        .selectAll('rect')
        .data(function (d) { return d.stints })
        .enter().append('rect')
        .attr('y', function (d) { return y(d.number) })
        .attr('x', function (d) { return x(d.start_time / 60) })
        .attr('width', function (d) { return x(d.end_time / 60) - x(d.start_time / 60) })
        .attr('height', y.bandwidth())
        .attr('class', barClass)

      var tickLabels = ['End Q1', 'End Q2', 'End Q3', 'End Q4']
      var tickValues
      if (this.$parent.league === 'wnba') {
        tickValues = [10, 20, 30, 40]
      } else {
        tickValues = [12, 24, 36, 48]
      }

      g.append('g')
        .attr('class', 'axis')
        .call(d3.axisTop(x).tickValues(tickValues).tickFormat(function (d, i) { return tickLabels[i] }))
        .append('text')
        .attr('y', 2)
        .attr('x', x(x.ticks().pop()) + 0.5)
        .attr('dx', '0.32em')
        .attr('fill', '#000')
        .attr('font-weight', 'bold')
        .attr('text-anchor', 'start')

      g.append('g')
        .selectAll('.game-flow-player-label')
        .data(data)
        .enter()
        .append('text')
        .attr('class', 'game-flow-player-label')
        .attr('x', -1 * margin.left)
        .attr('y', function (d) { return y(d.number) + margin.top })
        .text(function (d) { return (d.name) })
    },
    addScoreMargin (data, maxTime) {
      d3.select('svg#margin').html('')
      var svg = d3.select('svg#margin')
      var margin = {top: 20, right: 20, bottom: 20, left: 100}
      var width = +svg.attr('width') - margin.left - margin.right
      var height = +svg.attr('height') - margin.top - margin.bottom
      var g = svg.append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')

      var x = d3.scaleLinear()
        .rangeRound([0, width])

      var y = d3.scaleLinear()
        .rangeRound([0, height])

      x.domain([0, maxTime / 60])
      var maxScore = d3.max(data, function (d) { return d.margin })
      var minScore = d3.min(data, function (d) { return d.margin })
      var max = d3.max([maxScore, -1 * minScore], function (d) { return d })
      y.domain([-1 * max, max])

      g.append('g')
        .selectAll('rect')
        .data(data)
        .enter()
        .append('rect')
        .attr('y', function (d) {
          if (d.margin > 0) {
            return height / 2
          } else {
            return y(d.margin)
          }
        })
        .attr('x', function (d) { return x(d.start_time / 60) })
        .attr('width', function (d) { return x(d.end_time / 60) - x(d.start_time / 60) })
        .attr('height', function (d) {
          if (d.margin > 0) {
            return y(d.margin) - height / 2
          } else {
            return height / 2 - y(d.margin)
          }
        })
        .attr('class', function (d) {
          if (d.margin >= 0) {
            return 'home-team'
          } else {
            return 'visitor-team'
          }
        })

      var yAxis = d3.axisLeft().scale(y).ticks(5)
      svg.append('g')
        .attr('class', 'y axis')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
        .call(yAxis)
    }
  }
}
</script>

<style>
#team-container2{min-width:40%;  display:inline-block;}
#team-container{min-width:350px; width:100%;}

.game-flow-player-label {
  font: 10px sans-serif;
}

svg rect.home-team {
  fill: rgb(245, 123, 9);
}

svg rect.visitor-team {
  fill: rgb(13, 17, 241);
}

.legend {
  list-style: none;
}
.legend li {
  float: left;
  margin: 10px;
}
.legend span {
  border: 1px solid #ccc;
  float: left;
  width: 12px;
  height: 12px;
}

.legend {
  font: 12px sans-serif;
}

#possession_by_possession_container table th {
  text-align: center;
}

#possession_by_possession_container table td.scored, .legend .scored {
  background-color: green;
}

#possession_by_possession_container table td.turnover, .legend .turnover {
  background-color: red;
}

#possession_by_possession_container table, td, tr {
  border: 1px solid black;
}

#possession_by_possession_container table td.home_time {
  text-align: left;
}

#possession_by_possession_container table td.visitor_time {
  text-align: right;
}

#possession_by_possession_container table tr.home_possession {
  background-color: #b6b4b4;
}

#possession_by_possession_container table tr.period_start {
  border-top: 3px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/Live.vue